export const CHIP_BASE_CLASSES =
    'flex h-6 shrink-0 items-center gap-1 rounded-lg ps-1 pe-2 text-sm text-gray-700 whitespace-nowrap group-hover:bg-gray-300';

export const getChipBackplateClass = (isSelected: boolean) =>
    isSelected ? 'bg-gray-300' : 'bg-gray-200';
